/* eslint-disable import/prefer-default-export */
import cloneDeep from 'lodash.clonedeep';
import { FormTemplate } from 'data/template/template.types';
import { SshSecurityInfo } from 'data/sshSecurityInfo/sshSecurityInfo.types';

export type ListenersIpAddressPortsType = {
  [key:string]: string[],
}

export function adaptTemplateVisibilityMode(
  template: FormTemplate | undefined,
  mode: 'create' | 'edit' | 'view' | 'copy',
): FormTemplate | undefined {
  if (template == null) {
    return;
  }

  const clonedTemplate = cloneDeep(template);

  if (mode === 'view') {
    setAllFieldsAsReadOnlyExcludingFields(clonedTemplate, []);
  }

  if (mode === 'edit') {
    setDisabledValueToField(clonedTemplate, 'SS8ID', true);
  }

  clonedTemplate.formId = Date.now().toString();
  return clonedTemplate;
}

function setAllFieldsAsReadOnlyExcludingFields(template: FormTemplate, excludingFields: string[]) {
  Object.entries(template).forEach(([_templateKey, templateEntry]) => {
    if (typeof templateEntry === 'string') {
      return;
    }
    Object.entries(templateEntry.fields).forEach(([fieldKey, fieldEntry]) => {
      if (!excludingFields.includes(fieldKey)) {
        fieldEntry.readOnly = true;
      }
    });
  });
}

export function adaptSshSecurityInfoTemplate(
  template: FormTemplate,
  fieldName: string,
  value: string,
  sshSecurityInfo: SshSecurityInfo,
  selectedTlsType?: string,
  selectedAuthenType?: string,
  mode?: 'create' | 'edit',
): FormTemplate {

  const clonedTemplate = cloneDeep(template);

  const authType = sshSecurityInfo.AUTHTYPE?.toLocaleLowerCase();
  const isAuthTypeShhkeys = authType === 'sshkeys';

  if (!clonedTemplate.main?.fields) {
    return clonedTemplate;
  }

  setRequidedValidationToField(clonedTemplate, 'PASSWORD', !isAuthTypeShhkeys);
  setRequidedValidationToField(clonedTemplate, 'PRIVKEYFILENAME', isAuthTypeShhkeys);
  setRequidedValidationToField(clonedTemplate, 'PUBKEYFILENAME', isAuthTypeShhkeys);
  setRequidedValidationToField(clonedTemplate, 'SSHDIR', isAuthTypeShhkeys);

  if (mode === 'edit') {
    setDisabledValueToField(clonedTemplate, 'SS8ID', true);
  }

  clonedTemplate.key = Date.now().toString();
  clonedTemplate.formId = Date.now().toString();

  return clonedTemplate;
}

function setDisabledValueToField(template: FormTemplate, fieldName: string, disabled: boolean) {
  const formSection = (template.main);
  const field = formSection?.fields[fieldName];

  if (field) {
    field.disabled = disabled;
  }
}

function setRequidedValidationToField(template: FormTemplate, fieldName: string, required: boolean) {
  const formSection = (template.main);
  if (formSection == null) {
    return;
  }

  const field = formSection.fields[fieldName];
  if (field == null) {
    return;
  }

  if (field.validation){
    field.validation.required = required;
  }
}
